import { Banknote } from "lucide-react";
import { autoPill } from "@/components/shared/Pill";
import { AMOUNT_MODES } from "@/lib/documents";

// 389: Zobrazení › Částky (Doklady, 391: Objednávky) — bez DPH / s DPH / obojí; výchozí podle firmy (plátce bez DPH).
export const AM_HINT = { net: "bez DPH", gross: "s DPH", both: "bez i s DPH" };
export const AM_HEAD = { net: "Bez DPH", gross: "S DPH", both: "Bez DPH · s DPH" };
const AM_KEYS = ["net", "gross", "both"];

export function AmountPick({ am, defAm, mobile, onPick, testid = "docs-amounts" }) {
  return (
    <div className="space-y-1.5 pt-2" data-testid={testid}>
      <div className="flex items-center gap-1.5 text-xs font-semibold text-muted-foreground px-0.5"><Banknote size={14} />Částky</div>
      <div ref={autoPill} className="flex p-1 gap-0.5 bg-secondary rounded-[11px] min-w-0" role="radiogroup" aria-label="Částky">
        {AM_KEYS.map((k) => (
          <button key={k} type="button" role="radio" aria-checked={am === k} onClick={() => onPick(k)} data-testid={`${testid}-${k}`}
            className={`flex-1 min-w-0 ${mobile ? "h-10 text-[14.5px]" : "h-8 text-[13px]"} px-2.5 rounded-[8px] font-semibold whitespace-nowrap truncate
              ${am === k ? "bg-card text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"}`}>
            {AMOUNT_MODES[k]}{k === defAm && !mobile && <span className="ml-1 text-[11px] font-medium text-muted-foreground">výchozí</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
